module.exports = __webpack_public_path__ + "static/media/rsna18-day-top10.9a5da07f.svg";